import './PrivacyNote.css';

export type PrivacyState = 'on-device' | 'no-server' | 'published';

const labels: Record<PrivacyState, string> = {
  'on-device': 'Stays on this device',
  'no-server': 'Nothing sent to a server',
  published: 'Published · visible to others',
};

export interface PrivacyNoteProps {
  state: PrivacyState;
}

export function PrivacyNote({ state }: PrivacyNoteProps): JSX.Element {
  return (
    <span className={`bl-privacy bl-privacy--${state}`} data-state={state} role="status">
      <span className="bl-privacy__dot" aria-hidden="true" />
      {labels[state]}
    </span>
  );
}
